import { createContext, useContext, useEffect, useState } from 'react';

type Theme = 'dark' | 'light' | 'system';

interface ThemeContextType {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  resolvedTheme: 'dark';
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}

export function getSystemTheme(): 'light' | 'dark' {
  if (typeof window === 'undefined') return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function getStoredTheme(): Theme {
  // Siempre retornar dark
  return 'dark' as Theme;
}

export function setStoredTheme(theme: Theme) {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem('ndh-wallet-theme', 'dark');
  } catch {
    // Silently fail if localStorage is not available
  }
}

export function applyTheme(theme: 'light' | 'dark') {
  if (typeof window === 'undefined') return;
  
  const root = window.document.documentElement;
  const isDark = theme === 'dark';
  
  root.classList.remove('light', 'dark');
  root.classList.add(theme);
  
  // Also set data attribute for additional styling needs
  root.setAttribute('data-theme', theme);
}

export function resolveTheme(_theme: Theme): 'dark' {
  // Siempre dark
  return 'dark';
}